// extracted by mini-css-extract-plugin
export default {"card":"AZ-z","carouselContainer":"BZ-z","carouselContent":"CZ-z"};